<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card>
            <v-tabs v-model="tab" grow>
              <v-tab v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item
                :transition="false"
                :reverse-transition="false"
                key="Details"
              >
                <v-card flat class="text-left p-0">
                  <Details />
                </v-card>
              </v-tab-item>
              <v-tab-item
                :transition="false"
                :reverse-transition="false"
                key="Users"
              >
                <Users />
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/PartnerHub';
import Details from '@/components/partner/Details';
import Users from '@/components/partner/Users';

export default {
  name: 'Tier2PartnerDetails',
  components: {
    LayoutBasic,
    Details,
    Users,
  },
  data() {
    return {
      partner: [],
      partnerInfo: [],
      loading: false,
      tab: null,
      items: ['Details', 'Customers'],
      partnerId: this.$route.params.id,
      params: '',
      searchParams: '',
    };
  },
};
</script>
